<template>
  <div class="modal">
    <div class="modal__top-section">
      <img
        src="https://epaylater-web-static-assets-epl.s3.ap-south-1.amazonaws.com/promotion/epl-v2-marketting.png"
        alt="Promo Image"
        class="modal__top-section__image"
      />
    </div>
    <div class="modal__bottom-section">
      <p class="modal__bottom-section__text">
        <b>Thank you for showing your interest in ePayLater!</b>
        <br />
        <br />We have registered your request for signing up for our services! Currently we have restricted new signups as we
        prepare
        to launch an enhanced ePayLater 2.0 for our audience. We will be reaching out to you soon for joining our
        portal.
      </p>
      <div class="modal__bottom-section__actions">
        <a
          href="https://go.aws/33yqqiW"
          class="modal__bottom-section__actions__button modal__bottom-section__actions__button--primary"
        >Explore ePayLater</a>
      </div>
      <span class="redirectionmessage">
        Redirecting in
        <span class="timerChange">{{timer}}</span>
        seconds...
      </span>
    </div>
  </div>
</template>
<script>
export default {
  name: "SignupBlocked",
  data() {
    return {
      timer: 30,
      timerInterval: undefined
    };
  },
  methods: {},
  mounted() {
    this.timerInterval = setInterval(() => {
      if (this.timer > 0) {
        this.timer -= 1;
      } else {
        window.location =
          "https://epaylater-marketing.s3.ap-south-1.amazonaws.com/V2-landing/epaylater-website-v3/v2-landing-1.html";
      }
    }, 1000);
  }
};
</script>
<style lang="scss">
@import url("https://fonts.googleapis.com/css?family=Overpass:300,400,600");

.modal {
  width: 100vw;
  bottom: 0;
  z-index: 11;
  position: fixed;
  border-top-left-radius: 05px;
  border-top-right-radius: 05px;
  left: 0;
  z-index: 9999;
  display: block;
  @media only screen and (min-width: 640px) {
    width: unset;
    max-width: 540px;
    min-height: max-content;
    bottom: unset;
    background: #fff;
    bottom: unset;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 5px;
  }
  &__close-button {
    position: absolute;
    right: 10px;
    top: 10px;
  }
  &__top-section {
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    display: flex;
    &__image {
      width: 100%;
    }
  }
  &__bottom-section {
    padding: 40px 30px;
    background: #fff;
    padding-top: 20px;
    &__text {
      margin-bottom: 0;
      font-size: 16px;
      text-align: center;
      color: #4d4d4d;
      line-height: 24px;
      font-weight: 300;
    }
    &__text b {
      margin-bottom: 0;
      font-size: 20px;
      text-align: center;
      color: #4d4d4d;
      line-height: 24px;
      font-weight: 600;
    }
    &__actions {
      margin-top: 20px;
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
      gap: 20px;
      justify-content: center;
      &__button {
        border-radius: 4px;
        font-size: 16px;
        font-weight: 900;
        letter-spacing: 0.34px;
        color: #fff;
        text-align: center;
        padding: 15px;
        width: 100%;
        margin-top: 24px;
        box-shadow: none;
        outline: none;
        border: none;
        display: block;
        border: solid 0.6px #3482fd;
        text-decoration: none;
        cursor: pointer;
        @media only screen and (min-width: 640px) {
          max-width: 200px;
          margin-left: auto;
          margin-right: auto;
        }
        &--primary {
          border-radius: 6px;
          background-color: #3482fd;
          color: #fff;
        }
        &--secondary {
          border-radius: 6px;
          background-color: #fff;
          color: #3482fd;
        }
      }
    }
  }
}

.redirectionmessage {
  text-align: center;
  margin-top: 2rem;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/SignupBlocked.vue